import React, { Component } from 'react';
import { MODAL_FORM_TEACHER, hideModal } from '../../../../modules/modals';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import FormContent from './components/FormContent/FormContent';

class ModalFormTeacher extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state  = {
      modal: false,
    }
  }
  

  handleClose = () => {
    this.setState({
      modal: true
    })
  }

  handleClose2 = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_FORM_TEACHER});
  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleAddNewTeacher"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
    const {zIndex} = this.props;
    const {modal} = this.state;
    const {formatMessage} = this.context

    return (
      <React.Fragment>
        <Modal
          isOpen = {modal}
          style = {{
              overlay : {zIndex: 999999},
          }}
          onRequestClose={() => {}}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
        >
          <div className="create-dialog-modal-content__header">
            <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseTeacherModal')}</div>
          </div>
          <div className="create-dialog-modal-content__body">
            <div className="create-dialog-form form-quiz-create">
              <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextTeacherModal')}</div>
              <div className="create-dialog-form__group flex">
                <button className="btn btn-primary" type="button" onClick={this.handleClose2}>{formatMessage('Yes')}</button>
                <button className="btn btn-warning" type="button" onClick={() => this.setState({modal: false})}>{formatMessage('No')}</button>
              </div>
            </div>
            
          </div>
        </Modal>
        <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content ModalFormQbm"
        >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <FormContent {...this.props} handleClose={this.handleClose} handleClose2={this.handleClose2} />
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  hideModal
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalFormTeacher)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/UserOrganisation/components/ModalForm/ModalFormTeacher.jsx